<p-dialog
    [header]="'auth.webauthn_register' | translate"
    [visible]="visible()"
    (visibleChange)="visibleChange.emit($event)"
    [modal]="true"
    [style]="{width: '500px'}"
    [draggable]="false"
    [resizable]="false"
    (onShow)="onShow()">

    <div class="flex flex-col items-center gap-6 py-4">
        <!-- Icon -->
        <div class="w-20 h-20 rounded-full flex items-center justify-center"
             [class.bg-blue-100]="currentStep() === 'check' || currentStep() === 'ready'"
             [class.bg-yellow-100]="currentStep() === 'registering'"
             [class.bg-green-100]="currentStep() === 'success'"
             [class.bg-red-100]="currentStep() === 'error'">
            @if (currentStep() === 'check' || currentStep() === 'registering') {
                <p-progressSpinner strokeWidth="4" [style]="{width: '40px', height: '40px'}"></p-progressSpinner>
            } @else if (currentStep() === 'ready') {
                <i class="pi pi-key text-4xl text-blue-600"></i>
            } @else if (currentStep() === 'success') {
                <i class="pi pi-check text-4xl text-green-600"></i>
            } @else if (currentStep() === 'error') {
                <i class="pi pi-times text-4xl text-red-600"></i>
            }
        </div>

        <!-- Status Message -->
        <div class="text-center">
            <h3 class="text-lg font-semibold mb-2">{{ stepMessage() }}</h3>

            @if (currentStep() === 'ready') {
                <p class="text-gray-600 text-sm">
                    {{ 'auth.webauthn_instruction' | translate }}
                </p>

                <!-- Device name input -->
                <div class="mt-4 w-full text-left">
                    <label class="block text-sm font-medium text-gray-700 mb-1">
                        {{ 'users.deviceName' | translate }}
                        <span class="text-gray-400 font-normal ml-1">({{ 'general.optional' | translate }})</span>
                    </label>
                    <input
                        pInputText
                        class="w-full"
                        [placeholder]="'users.deviceNamePlaceholder' | translate"
                        [ngModel]="deviceName()"
                        (ngModelChange)="deviceName.set($event)"
                        maxlength="100" />
                </div>

                <!-- Platform authenticator info -->
                @if (platformAuthAvailable()) {
                    <p-message severity="info" size="small" icon="pi pi-info-circle" styleClass="mt-3 w-full">{{ 'auth.platform_auth_available' | translate }}</p-message>
                }
            }

            @if (currentStep() === 'registering') {
                <p class="text-gray-600 text-sm">
                    {{ 'auth.webauthn_waiting' | translate }}
                </p>
            }

            @if (currentStep() === 'success') {
                <p class="text-gray-600 text-sm">
                    {{ 'auth.webauthn_success' | translate }}
                </p>
            }
        </div>

        <!-- Error Message -->
        @if (currentStep() === 'error' && errorMessage()) {
            <p-message severity="error" [text]="errorMessage()!" styleClass="w-full"></p-message>
        }

        <!-- Compatibility Info -->
        @if (currentStep() === 'ready') {
            <div class="w-full border-t pt-4">
                <div class="flex items-center gap-2 text-sm">
                    <i class="pi" [class.pi-check-circle]="webAuthnSupported()" [class.text-green-600]="webAuthnSupported()"
                       [class.pi-times-circle]="!webAuthnSupported()" [class.text-red-600]="!webAuthnSupported()"></i>
                    <span>{{ 'auth.browser_support' | translate }}</span>
                </div>
                <div class="flex items-center gap-2 text-sm mt-2">
                    <i class="pi" [class.pi-check-circle]="serverEnabled()" [class.text-green-600]="serverEnabled()"
                       [class.pi-times-circle]="!serverEnabled()" [class.text-red-600]="!serverEnabled()"></i>
                    <span>{{ 'auth.server_enabled' | translate }}</span>
                </div>
                <div class="flex items-center gap-2 text-sm mt-2">
                    <i class="pi" [class.pi-check-circle]="platformAuthAvailable()" [class.text-green-600]="platformAuthAvailable()"
                       [class.pi-info-circle]="!platformAuthAvailable()" [class.text-gray-400]="!platformAuthAvailable()"></i>
                    <span>{{ 'auth.biometric_available' | translate }}</span>
                </div>
            </div>
        }
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            @if (currentStep() === 'error') {
                <p-button
                    [label]="'general.retry' | translate"
                    icon="pi pi-refresh"
                    severity="secondary"
                    (onClick)="retry()">
                </p-button>
            }

            @if (currentStep() === 'success') {
                <p-button
                    [label]="'general.done' | translate"
                    icon="pi pi-check"
                    (onClick)="complete()">
                </p-button>
            } @else {
                <p-button
                    [label]="'general.cancel' | translate"
                    icon="pi pi-times"
                    severity="secondary"
                    (onClick)="close()">
                </p-button>

                @if (currentStep() === 'ready') {
                    <p-button
                        [label]="'auth.register_device' | translate"
                        icon="pi pi-key"
                        [disabled]="!canRegister() || isLoading()"
                        (onClick)="startRegistration()">
                    </p-button>
                }
            }
        </div>
    </ng-template>
</p-dialog>
